// 🔄 이월금 관리 타입 정의

import type { Currency } from './newFinance';

// 월별 이월금 기록
export interface MonthlyCarryover {
    id: string;
    year: number;
    month: number;                    // 1-12

    // 전월 이월금 (받은 금액)
    previousBalance: CurrencyBalances;

    // 이번달 수입/지출 합계
    monthlyIncome: CurrencyBalances;
    monthlyExpense: CurrencyBalances;

    // 이번달 순수익
    monthlyNet: CurrencyBalances;

    // 다음달 이월 예정액 (계산: 전월이월 + 순수익)
    nextBalance: CurrencyBalances;

    // 확정 여부
    isConfirmed: boolean;
    confirmedAt?: Date;
    confirmedBy?: string;

    // 메타 정보
    createdAt: Date;
    updatedAt: Date;
    notes?: string;
}

// 연간 이월금 (연도 초기 설정용)
export interface AnnualCarryover {
    id: string;
    year: number;                     // 이월받는 연도 (예: 2025)
    sourceYear: number;               // 이월되는 연도 (예: 2024)

    // 이월 금액 (통화별)
    balances: CurrencyBalances;

    // 확정 정보
    isConfirmed: boolean;
    confirmedAt?: Date;
    confirmedBy?: string;

    // 메타 정보
    createdAt: Date;
    updatedAt: Date;
    notes?: string;
}

// 통화별 잔액
export interface CurrencyBalances {
    HUF: number;
    EUR: number;
    USD: number;
    KRW: number;
    GBP: number;
    CAD: number;
}

// 빈 잔액 초기값
export const EMPTY_BALANCES: CurrencyBalances = {
    HUF: 0,
    EUR: 0,
    USD: 0,
    KRW: 0,
    GBP: 0,
    CAD: 0,
};

// 이월금 폼 데이터
export interface AnnualCarryoverFormData {
    year: number;
    sourceYear: number;
    balances: CurrencyBalances;
    notes?: string;
}
